import Constants from '../actions/types';

const initialState = {
  fieldValueIndex: null,
  fieldValueIndexes: [],
  clusters: [],
  loading: false,
  message: null,
  severity: null
};

const fieldValueIndexesReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.FIELDVALUEINDEXES_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.FIELDVALUEINDEXES_GET_SUCCESS: {
      const newState = {
        ...state,
        fieldValueIndexes: action.payload,
        loading: false
      };

      return newState;
    }

    case Constants.FIELDVALUEINDEX_GET_FAILURE: {
      const newState = {
        fieldValueIndex: null,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.FIELDVALUEINDEX_GET_SUCCESS: {
      const newState = {
        ...state,
        fieldValueIndex: action.payload,
        loading: false
      };

      return newState;
    }

    case Constants.FIELDVALUEINDEXES_GET_FAILURE: {
      const newState = {
        fieldValueIndex: null,
        fieldValueIndexes: [],
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.FIELDVALUEINDEXCLUSTERS_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.FIELDVALUEINDEXCLUSTERS_GET_SUCCESS: {
      const newState = {
        ...state,
        clusters: action.payload,
        loading: false
      };

      return newState;
    }

    case Constants.FIELDVALUEINDEXCLUSTERS_GET_FAILURE: {
      const newState = {
        clusters: [],
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.FIELDVALUEINDEXES_NOT_FOUND: {
      const newState = {
        ...state,
        fieldValueIndexes: [],
        loading: false
      };

      return newState;
    }

    case Constants.FIELDVALUEINDEXES_SAVE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.FIELDVALUEINDEXES_REGEN_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.FIELDVALUEINDEXES_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default fieldValueIndexesReducer;
